import { render, staticRenderFns } from "./jgbIndex.vue?vue&type=template&id=1f55568e&scoped=true"
import script from "./jgbIndex.vue?vue&type=script&lang=js"
export * from "./jgbIndex.vue?vue&type=script&lang=js"
import style0 from "./jgbIndex.vue?vue&type=style&index=0&id=1f55568e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f55568e",
  null
  
)

export default component.exports